import type { CategoryInfo } from "@/types/video";

export const categories: CategoryInfo[] = [
  {
    id: "电影",
    name: "电影",
    icon: "ri-film-line",
    desc: "精选院线大片与口碑佳作，动作、科幻、悬疑一网打尽。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20interior%20with%20glowing%20warm%20orange%20screen%20light%20and%20empty%20seats%2C%20moody%20atmosphere%2C%20film%20grain%2C%20high%20detail&width=600&height=400&seq=ng-cat-movie&orientation=landscape",
  },
  {
    id: "电视剧",
    name: "电视剧",
    icon: "ri-tv-2-line",
    desc: "热播剧集与经典长剧，追更都市、古装、悬疑全类型。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20at%20night%20with%20television%20glowing%20orange%20light%20on%20a%20sofa%2C%20cinematic%20moody%20tones%2C%20high%20detail&width=600&height=400&seq=ng-cat-tv&orientation=landscape",
  },
  {
    id: "短片",
    name: "短片",
    icon: "ri-movie-2-line",
    desc: "精炼动人的微电影与创意短片，碎片时间也能收获感动。",
    poster:
      "https://readdy.ai/api/search-image?query=Artistic%20filmmaking%20scene%20with%20vintage%20camera%20and%20warm%20orange%20spotlight%20in%20dark%20studio%2C%20cinematic%20moody%20tones%2C%20high%20detail&width=600&height=400&seq=ng-cat-short&orientation=landscape",
  },
];